import styled from "styled-components";

export const OrganizacjePageStyle = styled.div`
  height: 100%;
  max-width: 1018px;
  display: grid;
  grid-template-rows: 72px auto 1fr;
  padding-left: 28px;
  grid-gap: 8px;

  header {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr auto;
  }

  .empty {
    display: grid;
    align-self: center;
    justify-items: center;
    grid-template-rows: 257px auto;
    grid-gap: 36px;
  }

  section {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: 1fr 1fr;
    align-content: start;
    padding-bottom: 24px;
  }
`;
